import React from 'react';
import ToggleButton from './ToggleButton';

interface ToggleButtonGroupProps {
  options: Array<{
    value: string;
    label: string;
    icon: React.ComponentType<{ size: number }>;
  }>;
  value: string;
  onChange: (value: string) => void;
  variant?: 'primary' | 'success' | 'warning';
}

const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ options, value, onChange, variant = 'primary' }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          active={value === option.value}
          onClick={() => onChange(option.value)}
          icon={option.icon}
          variant={variant}
        >
          {option.label}
        </ToggleButton>
      ))}
    </div>
  );
};

export default ToggleButtonGroup;
